import { Component } from "@angular/core";

@Component({
    templateUrl: './live-scroing.component.html'
})
export class LiveScoringComponent {

}